export const EMAIL_DOMAIN_LISTS = [
  'gmail.com',
  'yahoo.com',
  'outlook.com',
  'hotmail.com',
  'aol.com',
  'msn.com',
  'live.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'mail.com',
  'yandex.com',
  'gmx.com',
  'protonmail.com',
  'zoho.com',
  'yahoo.co.uk',
  'yahoo.co.in',
  'yahoo.co.jp',
  'yahoo.fr',
  'yahoo.de',
  'yahoo.ca',
  'yandex.ru',
  'ymail.com',
  'inbox.com',
  'hushmail.com',
  'rediffmail.com',
  'libero.it',
  'freemail.hu',
  'rambler.ru',
  'seznam.cz',
  'web.de',
  't-online.de',
  'mail.ru',
  'bk.ru',
  'list.ru',
  'nm.ru',
  'outlook.co.uk',
  'outlook.fr',
  'outlook.de',
  'hotmail.co.uk',
  'hotmail.fr',
  'hotmail.de',
  'tutanota.com',
  'fastmail.com',
  'posteo.net',
  'runbox.com',
  'startmail.com',
  'zoho.eu',
  'hey.com',
  'mailinator.com',
  'tempmail.com',
  '10minutemail.com',
  'guerrillamail.com',
  'yopmail.com',
  'fakeinbox.com',
  'getnada.com',
  'throwawaymail.com',
  'trashmail.com',
  'dispostable.com',
  'moakt.com',
  'maildrop.cc',
  'mytemp.email',
  'tempmailo.com',
  'qq.com',
  '163.com',
  '126.com',
  'sina.com',
  'daum.net',
  'naver.com',
  'hanmail.net',
  'wp.pl',
  'o2.pl',
  'interia.pl',
  'onet.pl',
  'orange.fr',
  'planet.nl',
  'bellsouth.net',
  'sbcglobal.net',
  'charter.net',
  'shaw.ca',
  'rogers.com',
  'telus.net',
];
